// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wYE7OG1X{display:flex;flex-direction:row;height:1.5rem;isolation:isolate;position:relative}.LJiO2kWn,.wYE7OG1X{align-items:center}.LJiO2kWn{border-radius:1rem;display:inline-flex;flex-shrink:0;font-size:.75rem;font-weight:600;height:1.25rem;justify-content:center;line-height:1rem;padding:.25rem .5rem;text-transform:capitalize;width:1.63rem}.LJiO2kWn+.LJiO2kWn{margin-left:-.13rem}._9TcRMGxq{font-size:.75rem}.OevDof6c{height:.69rem;left:1.06rem;pointer-events:none;position:absolute;top:.81rem;width:.69rem;z-index:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"langs": "wYE7OG1X",
	"lang": "LJiO2kWn",
	"langIcon": "_9TcRMGxq",
	"translateArrow": "OevDof6c"
};
module.exports = ___CSS_LOADER_EXPORT___;
